import formatDuration from "~/kernel/dateTime/formatDuration";

export default function formatTime({
  minTime,
  maxTime,
}: {
  minTime: number;
  maxTime: number;
}) {
  if (minTime === maxTime) {
    return formatDuration(minTime);
  }

  return `${formatDuration(minTime)} - ${formatDuration(maxTime)}`;
}
